import React from 'react';
import AKSearchIcon from '@atlaskit/icon/glyph/search';
import { N800 } from '@atlaskit/theme/colors';
export const SearchIcon = ({
  isExpanded,
  theme,
  size = 'small',
  primaryColor = `var(--ds-text, ${N800})`
}) => /*#__PURE__*/React.createElement(AKSearchIcon, {
  label: "search",
  primaryColor: isExpanded ? primaryColor : theme.default.color,
  size: size
});